var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBed = function SvgBed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5h-2V7.5A1.5 1.5 0 0 0 14.5 6h-2A1.5 1.5 0 0 0 11 7.5V9H9V7.5A1.5 1.5 0 0 0 7.5 6h-2A1.5 1.5 0 0 0 4 7.5V9H2V4Zm18 9.5V12a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v2.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 0 .5-.5v-1Z",
    clipRule: "evenodd"
  })));
};
export default SvgBed;